/* ZALOOQ: direct checkout action for product page. Does not alter Add to Cart. */
(function () {
  if (window.__zalooqBuyNowFixed) return;
  window.__zalooqBuyNowFixed = true;
  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-product-buy-now]');
    if (!button || button.disabled) return;
    var form = button.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();
    var panel = button.closest('.productView-groupBottom');
    var terms = panel && panel.querySelector('.global-checkbox--input');
    var error = panel && panel.querySelector('[data-buy-now-error]');
    if (error) { error.hidden = true; error.textContent = ''; }
    if (terms && !terms.checked) {
      if (error) { error.textContent = 'Please accept the terms and conditions first.'; error.hidden = false; }
      terms.focus();
      return;
    }
    var data = new FormData(form);
    var variantId = data.get('id');
    if (!variantId || !/^\d+$/.test(String(variantId))) {
      if (error) { error.textContent = 'Please select a product option.'; error.hidden = false; }
      return;
    }
    var quantity = Number(data.get('quantity') || 1);
    if (!Number.isInteger(quantity) || quantity < 1) {
      if (error) { error.textContent = 'Please select a valid quantity.'; error.hidden = false; }
      return;
    }
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    var label = button.querySelector('[data-buy-now-label]');
    if (label) label.textContent = 'Processing...';
    try {
      // Shopify cart API validates selected variant, stock, selling plan and product properties.
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (!root.endsWith('/')) root += '/';
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: data,
        credentials: 'same-origin'
      });
      if (!response.ok) {
        var result = await response.json().catch(function () { return {}; });
        throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
      }
      window.location.assign(root + 'checkout');
    } catch (err) {
      if (error) { error.textContent = err.message || 'Checkout could not start. Please try again.'; error.hidden = false; }
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (label) label.textContent = 'Buy Now';
    }
  }, true);
})();
